module.exports = __webpack_public_path__ + "assets/tomap.08e44c0c.svg";